import { render, staticRenderFns } from "./catetory.vue?vue&type=template&id=4e9e2409&scoped=true"
import script from "./catetory.vue?vue&type=script&lang=js"
export * from "./catetory.vue?vue&type=script&lang=js"
import style0 from "./catetory.vue?vue&type=style&index=0&id=4e9e2409&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9e2409",
  null
  
)

export default component.exports